<!--
- 搜索模态框组件
- anthor: wang.y
- greatTime: 2019-08-11
-->
<template>
    <div>
        <Modal
            v-model="searchIndex"
            @on-visible-change="searchModalCancel"
            :closable="false"
            :footer-hide="true"
            width="866"
            class="search-modal"
        >
            <Input
                v-model="key_word"
                placeholder="输入关键词"
                @on-enter="handleClickSearch"
                id="searchInput"
            >
                <i class="iconfont" slot="append" @click="handleClickSearch">&#xe6d7;</i>
                <span slot="append" class="line"></span>
            </Input>

            <div class="hot">
                <p># 热门搜索 #</p>
                <div class="tag-list">
                    <span v-for="item,index in hot_key">
                        <a :href="item.url" v-if="item.url" target="_blank" @click="handleChangeKeyWord2(item.name)">
                            <i class="iconfont" v-if="item.text_flag == 1">&#xe6d1;</i>{{item.name}}
                        </a>
                        <a href="javascript:void(0)" @click="handleChangeKeyWord(item.name)" v-else>
                            <i class="iconfont" v-if="item.text_flag == 1">&#xe6d1;</i>{{item.name}}
                        </a>
                    </span>
                </div>
            </div>
            <i class="iconfont close-modal" @click="handleCloseModal" v-show="searchIndex">&#xe6c2;</i>
        </Modal>
    </div>
</template>

<script>
import { hotElement } from '../service'
export default {
  inject: ['globalInsertRecords'],
  props: ['searchModal'],
  data() {
    return {
      searchIndex: false,
      hot_key: [],
      key_word: ''
    }
  },
  methods: {
    searchModalCancel() { //  取消模态框，更新状态
      if(this.searchIndex) {
        setTimeout(() => {$('#searchInput .ivu-input')[0].focus()},50)
      }
      this.key_word = ''
      this.$emit('searchcancel', this.searchIndex)
    },
    handleClickSearch() {
      this.globalInsertRecords({
        content_id: 13,
        content_type: 17,
        enter_type: 35,
        view_type: 1,
        keyword: this.key_word
      })
      // this.$router.replace({ name: 'SearchList', query: { keyword: this.key_word }})
      let link = this.$store.state.index2_path + '/home/search?keyword='+this.key_word
      window.open(link)
      this.handleCloseModal()
    },
    async getHotKey() {
      let res = await hotElement({size: 20, position_id:'3'}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'hot_key', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    handleChangeKeyWord(key_word) {
      this.globalInsertRecords({
        content_id: 13,
        content_type: 17,
        enter_type: 35,
        view_type: 1,
        keyword: key_word
      })
      // this.$router.replace({ name: 'SearchList', query: { keyword: key_word }})
      let link = this.$store.state.index2_path + '/home/search?keyword='+key_word
      window.open(link)
      _czc.push(['_trackEvent', '搜索', '热门搜索点击（'+key_word+'）'])
      this.handleCloseModal()
    },
    handleChangeKeyWord2(key_word) {
      _czc.push(['_trackEvent', '搜索', '热门搜索点击（'+key_word+'）'])
    },
    handleCloseModal() {
      this.searchIndex = false
      this.searchModalCancel()
    }
  },
  created() {
    this.getHotKey()
  },
  watch: {
    searchModal(value) {
      this.searchIndex = value
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.search-modal
  >>> .ivu-modal
    top: 140px
  >>> .ivu-modal-mask
    background-color: rgba(0,0,0,.9) !important;
  >>> .ivu-modal-content
    background-color: transparent
    border-radius: 0
    box-shadow: none
    .ivu-modal-body
      padding: 0
      line-height: 0
      .ivu-input-group
        position: relative
        .line
          position: absolute
          height: 2px
          width: 0
          background: rgba(250, 122, 80, 1)
          bottom: -14px
          left: -830px
          transition: all .5s
        .ivu-input
          padding: 10px 48px 10px 10px
          border: 0
          border-radius: 0
          background-color: transparent
          border-bottom: 2px solid #E9E9E9
          font-size: 36px
          line-height: 36px
          height: auto
          color #ffffff
          &:focus
            box-shadow: none
            &~.ivu-input-group-append .line
              width: 866px
          &::placeholder
            color #999999
        &-append
          position: absolute
          right: 0
          top: 14px
          padding: 0;
          font-weight: normal;
          line-height: 1;
          color #CCCCCC
          background-color: transparent;
          border: 0;
          border-radius: 0;
          width: 36px;
          height: 36px;
          cursor: pointer
          z-index: 2
          &:hover
            color: rgba(250, 122, 80, 1)
          .iconfont
            display: inline-block
            vertical-align: top
            font-size: 36px;
      .hot
        margin-top: 50px
        > p
          font-size: 20px
          color #E9E9EB
          font-weight: bold
          line-height: 1
        .tag-list
          padding-top: 1px
          span
            display: inline-block
            vertical-align: top
            margin: 15px 15px 0 0
          a
            display: inline-block
            vertical-align: top
            line-height: 1
            border: 0
            font-size: 16px
            padding: 9px 20px
            border: 1px solid rgba(250, 122, 80, 1)
            color #FA5A00
            background: rgba(0,0,0,0)
            &:hover
              color #ffffff
              background: rgba(250, 122, 80, 1)
            .iconfont
              background-color: #de0017
              font-size: 12px
              color: #fff
              line-height: 16px
              width: 16px
              border-radius: 50%
              display: inline-block
              vertical-align: top
              text-align: center
              margin-right: 6px
      .close-modal
        position: fixed
        right: 106px
        top: 90px
        font-size: 24px
        cursor: pointer
        color #CCCCCC
        &:hover
          color: rgba(250, 122, 80, 1)
</style>
